import { ATLAS_FEATURE_FLAG } from '@dtx-company/true-common/src/constants/featureFlags'
import { useFlowFeature } from '../useFlowFeature/useFlowFeature'

export function useAtlasFeatureFlag(): boolean {
  const [atlasEnabled] = useFlowFeature(ATLAS_FEATURE_FLAG)
  return atlasEnabled
}
